import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPrivacyPolicyData } from "../../Store/Reducer/common.slice";
import { TRADE_BAZAAR_COPYRIGHT } from "../../constants/legalContent";
import { formatPolicyText } from "../../utils/formatPolicyText";
import PolicyHtmlContent from "./PolicyHtmlContent";
import "./PrivacyPolicyPage.scss";

export default function PrivacyPolicyPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { privacyPolicyView, privacyPolicyLoading, privacyPolicyError } = useSelector(
    ({ common }) => common
  );

  useEffect(() => {
    dispatch(getPrivacyPolicyData());
  }, [dispatch]);

  const title = privacyPolicyView?.title || "Privacy Policy";
  const contentHtml = privacyPolicyView?.contentHtml || "";
  const rules = privacyPolicyView?.rules || [];
  const hasHtml = Boolean(contentHtml?.trim());
  const count = rules.length;

  return (
    <div className="privacy-page">
      <header className="privacy-page__header">
        <button type="button" className="privacy-page__back" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <div className="privacy-page__header-title">
          <span className="privacy-page__header-eyebrow">FxBazzar</span>
          <h1>{title}</h1>
        </div>
      </header>

      <main className="privacy-page__main">
        <section className="privacy-page__intro">
          <h2></h2>
          <p>
            
          </p>
        </section>

        <div className="privacy-page__content">
        {privacyPolicyLoading && (
          <div className="privacy-page__state">
            <span className="privacy-page__spinner" aria-hidden />
            Loading policy…
          </div>
        )}

        {!privacyPolicyLoading && privacyPolicyError && (
          <div className="privacy-page__state privacy-page__state--error">{privacyPolicyError}</div>
        )}

        {!privacyPolicyLoading && !privacyPolicyError && hasHtml && (
          <div className="privacy-page__html-wrap">
            <PolicyHtmlContent html={contentHtml} />
          </div>
        )}

        {!privacyPolicyLoading && !privacyPolicyError && !hasHtml && count > 0 && (
          <>
            <div className="privacy-page__meta">
              <span className="privacy-page__badge">{count} guidelines</span>
            </div>

            <ol className="privacy-page__rules">
              {rules.map((item, index) => (
                <li key={`policy-${index}`} className="privacy-page__rule">
                  <span className="privacy-page__rule-num" aria-hidden>
                    {index + 1}
                  </span>
                  <p className="privacy-page__rule-text">{formatPolicyText(item)}</p>
                </li>
              ))}
            </ol>
          </>
        )}

        {!privacyPolicyLoading && !privacyPolicyError && !hasHtml && count === 0 && (
          <div className="privacy-page__state">No privacy policy content is available yet.</div>
        )}

        <footer className="privacy-page__footer">
          <p>{TRADE_BAZAAR_COPYRIGHT}</p>
        </footer>
        </div>
      </main>
    </div>
  );
}
